<div class="ly-sp-m-top">
    <!-- Title container -->
    <div class="ly-sp-s-bottom">
        <span class="bs-h2 th-text-main" *ngIf="getTitle() !== ''">{{ getTitle() }}</span>
    </div>

    <!-- Button CardOverview container -->
    <div class="ly-sp-m-top">
        <!-- Div wrapper -->
            <div class="button-container-wrapper" 
                [ngClass]="{
                'two-columns-medium': isMediumSize && (getAmountChildElements() >= 2),
                'two-columns-small': isSmallSize && (getAmountChildElements() >= 2),
                'single-column-small': isSmallSize && (getAmountChildElements() === 1),
                'single-column-medium': isMediumSize && (getAmountChildElements() === 1),
                'single-row-extra-small': isExtraSmall
                }"> 
                <ng-container #buttonContainer></ng-container>
            </div>
    </div>
</div>